import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { Router, RouterLink } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CompanyService } from 'src/app/_services/company.service';
import { CacheService } from 'src/app/_services/cache.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'aside[app-sidebar]',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private router: Router,
    private companyService: CompanyService,
    public cacheService: CacheService,
    public translate: TranslateService
  ) {}

  isSuperAdmin: boolean;
  idCompany: number;
  showMicrosoftPurview = true;
  currentLogo: any = 'a';
  private subscriptions: Subscription[] = [];

  ngOnInit() {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        this.idCompany = Number(payload.idCompany);
        this.showMicrosoftPurview = this.idCompany !== 1075;
      } catch {
        this.showMicrosoftPurview = true;
      }
    }

    const isAdminSub = this.authService.isAdmin().subscribe((res) => {
      this.isSuperAdmin = !!res;
    });
    this.subscriptions.push(isAdminSub);

    const logoSub = this.companyService.getByUser().subscribe(
      (res: any) => {
        this.currentLogo = res?.body?.logo;
      },
      (err) => err
    );
    this.subscriptions.push(logoSub);
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        if (sub && !sub.closed) {
          sub.unsubscribe();
        }
      });
      this.subscriptions = [];
    }
  }
}
